/**
 * FavoritesList
 * @module components/FavoritesList
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './FavoritesList.scss';

import { FavoritesConsumer } from 'context/favorites.context';
import { I18nContext } from 'context/i18n.context';
import Link from 'common/Link/Link';
import Icon from 'components/Icon';
import { DropDown, DropDownTitle, DropDownList } from '../DropDown';

/** Class representing the component. */
class FavoritesList extends Component {

	static contextType = I18nContext;

	constructor(props) {
		super(props);

		this.state = {
			icon: 'icon-angle-down'
		};
	}

	/**
	 * Renders the dropdown list with pages
	 * @param {Array} pages - Array of favorited pages
	 */
	renderDropDownList (pages, removePage) {
		const { t } = this.context;

		return (
			<DropDownList>
				{ pages.map((item, i) => {
					return (
						<li className={style.item} key={i}>
							<Link route={item.url}>
								<a className={style.favorites}>
									{item.title.length > 50 ? `${item.title.slice(0, 49)}...` : item.title}
								</a>
							</Link>
							<a href="#" onClick={(e) => { e.preventDefault(); removePage(item.url); }}>
								<Icon icon="icon-close" />
								<span className="is-visuallyhidden">{t('remove')} {item.title} {t('fromMyFavorites')}</span>
							</a>
						</li>
					);
				})}
			</DropDownList>
		);
	}


	/**
	 * Renders the dropdown title
	 * @param {Array} pages - Array of favorited pages
	 */
	renderDropDownTitle (pages) {
		const { t } = this.context;

		return (
			<DropDownTitle>
				<span onMouseOver={() => this.setState({ icon: 'icon-angle-up' })}>
					<Icon icon="icon-thumbs-o-up" color="turquoise" />
					<span className={style.title}>
						{t('myFavourites')} <span className={style.number}>({ pages && pages.length ? pages.length : 0 })</span>
					</span>

					{ pages && pages.length > 0 && <Icon icon={this.state.icon} /> }
				</span>
			</DropDownTitle>
		);
	}


	/**
	 * The render method
	 */
	render () {
		return (
			<FavoritesConsumer>
				{({ pages, removePage }) => (
					<div className={style.favoritesList} onMouseLeave={() => this.setState({ icon: 'icon-angle-down' })}>

						<DropDown>
							{ this.renderDropDownTitle(pages) }
							{ pages && pages.length > 0 && this.renderDropDownList(pages, removePage) }
						</DropDown>

					</div>
				)}
			</FavoritesConsumer>
		);
	}
}


/** Prop types **/
FavoritesList.propTypes = {

};


export default FavoritesList;
